module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_23.fe55852e.png";